/* C9 Autoworkz — garage, Year/Make/Model finder, fitment checks */
(function () {
  if (window.C9) return;

  var KEY = 'c9:garage';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  var ICON_WARN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 9v4m0 4h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"/></svg>';
  var ICON_CAR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 17H3v-4l2-5h11l4 4h1v5h-2"/><circle cx="7.5" cy="17" r="2"/><circle cx="16.5" cy="17" r="2"/><path d="M9.5 17h5"/></svg>';

  /* ---------- storage ---------- */
  var garage = {
    get: function () { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } },
    set: function (v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} emit(); },
    clear: function () { try { localStorage.removeItem(KEY); } catch (e) {} emit(); }
  };
  function emit() { document.dispatchEvent(new CustomEvent('c9:garage', { detail: garage.get() })); }

  /* ---------- data ---------- */
  var cache = null;
  function data() {
    if (cache) return cache;
    var el = document.querySelector('script[data-c9-vehicles]');
    if (!el) return null;
    try { cache = JSON.parse(el.textContent); } catch (e) { return null; }
    cache.platforms = {};
    cache.makes.forEach(function (m) { m.models.forEach(function (md) { md.p.forEach(function (p) { cache.platforms[p.h] = { make: m.n, model: md.n, p: p }; }); }); });
    cache.catHandles = {};
    cache.cats.forEach(function (c) { cache.catHandles[c.h] = c.n; c.s.forEach(function (s) { cache.catHandles[s.h] = s.n; }); });
    cache.catHandles.all = 'All parts';
    return cache;
  }

  function url(path) { return ROOT.replace(/\/$/, '') + path; }
  function vehicleUrl(g, cat) { return cat ? url('/collections/' + cat + '/fits-' + g.h) : url('/collections/' + g.h); }
  function label(g) { return g ? (g.year + ' ' + g.make + ' ' + g.model) : ''; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function opt(value, text) { var o = document.createElement('option'); o.value = value; o.textContent = text; return o; }
  function reset(select, placeholder) { select.innerHTML = ''; select.appendChild(opt('', placeholder)); }

  /* ---------- finder ---------- */
  function initFinder(form) {
    if (form.__c9) return; form.__c9 = true;
    var D = data(); if (!D) return;
    var f = form.elements, sMake = f.make, sModel = f.model, sYear = f.year, sCh = f.chassis, sCat = f.cat;
    var chWrap = form.querySelector('[data-c9-chassis]');
    var btn = form.querySelector('[type="submit"]');

    reset(sMake, 'Select make');
    D.makes.forEach(function (m) { sMake.appendChild(opt(m.n, m.n)); });
    if (sCat) {
      reset(sCat, 'All parts');
      D.cats.forEach(function (c) {
        var og = document.createElement('optgroup'); og.label = c.n;
        og.appendChild(opt(c.h, 'All ' + c.n));
        c.s.forEach(function (s) { og.appendChild(opt(s.h, s.n)); });
        sCat.appendChild(og);
      });
    }

    function make() { var v = sMake.value; return D.makes.filter(function (m) { return m.n === v; })[0]; }
    function model() { var m = make(), v = sModel.value; return m && m.models.filter(function (x) { return x.n === v; })[0]; }
    function matches() {
      var md = model(), y = parseInt(sYear.value, 10);
      if (!md || !y) return [];
      return md.p.filter(function (p) { return y >= p.y[0] && y <= p.y[1]; });
    }
    function selected() {
      var ps = matches();
      if (ps.length === 1) return ps[0];
      if (ps.length > 1 && sCh.value) return ps.filter(function (p) { return p.h === sCh.value; })[0];
      return null;
    }
    function update() { btn.disabled = !selected(); }

    function onMake() {
      var m = make();
      reset(sModel, 'Model'); reset(sYear, 'Year');
      sModel.disabled = !m; sYear.disabled = true; if (chWrap) chWrap.hidden = true;
      if (m) m.models.forEach(function (md) { sModel.appendChild(opt(md.n, md.n)); });
      update();
    }
    function onModel() {
      var md = model(); reset(sYear, 'Year'); sYear.disabled = !md; if (chWrap) chWrap.hidden = true;
      if (md) {
        var years = {};
        md.p.forEach(function (p) { for (var y = p.y[1]; y >= p.y[0]; y--) years[y] = 1; });
        Object.keys(years).map(Number).sort(function (a, b) { return b - a; }).forEach(function (y) { sYear.appendChild(opt(y, y)); });
      }
      update();
    }
    function onYear() {
      var ps = matches();
      if (chWrap) {
        chWrap.hidden = ps.length < 2;
        reset(sCh, 'Select chassis');
        if (ps.length > 1) ps.forEach(function (p) { sCh.appendChild(opt(p.h, p.c)); });
      }
      update();
    }
    sMake.addEventListener('change', onMake);
    sModel.addEventListener('change', onModel);
    sYear.addEventListener('change', onYear);
    if (sCh) sCh.addEventListener('change', update);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var p = selected(); if (!p) return;
      var g = { year: sYear.value, make: sMake.value, model: sModel.value, h: p.h, c: p.c, t: p.t };
      garage.set(g);
      window.location.href = vehicleUrl(g, sCat && sCat.value);
    });

    function prefill() {
      var g = garage.get(); if (!g || !D.platforms[g.h]) return;
      sMake.value = g.make; onMake();
      sModel.value = g.model; onModel();
      sYear.value = g.year; onYear();
      if (sCh && chWrap && !chWrap.hidden) { sCh.value = g.h; }
      update();
    }
    prefill();
    document.addEventListener('c9:garage', function () { if (!garage.get()) { sMake.value = ''; onMake(); } });
  }

  /* ---------- garage bar ---------- */
  function initBar(bar) {
    if (bar.__c9) return; bar.__c9 = true;
    var sheet = bar.querySelector('[data-c9-sheet]');
    var toggle = bar.querySelector('[data-c9-toggle]');
    var lastFocus = null;
    if (sheet) {
      /* Portal the sheet to <body> so it always sits above the sticky header */
      document.querySelectorAll('body > [data-c9-sheet]').forEach(function (n) { if (n.id === sheet.id && n !== sheet) n.remove(); });
      if (bar.style.getPropertyValue('--c9-accent')) sheet.style.setProperty('--c9-accent', bar.style.getPropertyValue('--c9-accent'));
      document.body.appendChild(sheet);
    }

    function open() {
      if (!sheet) return;
      lastFocus = document.activeElement;
      sheet.hidden = false; document.documentElement.classList.add('c9-lock');
      toggle && toggle.setAttribute('aria-expanded', 'true');
      var first = sheet.querySelector('select:not([disabled])'); first && setTimeout(function () { first.focus(); }, 60);
    }
    function close() {
      if (!sheet || sheet.hidden) return;
      sheet.hidden = true; document.documentElement.classList.remove('c9-lock');
      toggle && toggle.setAttribute('aria-expanded', 'false');
      lastFocus && lastFocus.focus && lastFocus.focus();
    }
    toggle && toggle.addEventListener('click', open);
    sheet && sheet.querySelectorAll('[data-c9-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('c9:open', open);
    var clear = sheet && sheet.querySelector('[data-c9-clear]');
    clear && clear.addEventListener('click', function () { garage.clear(); close(); });

    function render() {
      var g = garage.get(), D = data();
      var lab = bar.querySelector('[data-c9-label]'), kicker = bar.querySelector('[data-c9-kicker]'), action = bar.querySelector('[data-c9-action-text]'), shop = bar.querySelector('[data-c9-shop]');
      bar.classList.toggle('has-vehicle', !!g);
      if (g) {
        kicker.textContent = 'My vehicle · ' + g.make;
        lab.innerHTML = '<span class="c9-bar__name">' + esc(g.year + ' ' + g.model) + '</span>' + (g.c ? '<span class="c9-chip-code">' + esc(g.c) + '</span>' : '');
        action.textContent = 'Change';
        shop.href = vehicleUrl(g);
      } else {
        kicker.textContent = 'Shop by vehicle';
        lab.textContent = 'Select your vehicle';
        action.textContent = 'Select';
      }
      if (clear) clear.hidden = !g;
      renderContext(g, D);
    }

    function renderContext(g, D) {
      var box = bar.querySelector('[data-c9-context]'); if (!box || !D) return;
      var handle = bar.getAttribute('data-collection') || '';
      var tags = (bar.getAttribute('data-tags') || '').split(',').filter(Boolean);
      var html = '';
      if (handle && D.platforms[handle]) {
        html += '<span class="c9-context__label">Shop</span>';
        D.cats.forEach(function (c) { html += '<a class="c9-pill" href="' + url('/collections/' + c.h + '/fits-' + handle) + '">' + esc(c.n) + '</a>'; });
      } else if (g && handle && D.catHandles[handle]) {
        var tag = 'fits-' + g.h;
        if (tags.indexOf(tag) > -1) {
          html += '<span class="c9-pill c9-pill--ok">' + ICON_CHECK + 'Fits your ' + esc(g.model + ' ' + (g.c || '')) + '</span>';
          html += '<a class="c9-pill" href="' + url('/collections/' + handle) + '">Show all ' + esc(D.catHandles[handle]) + '</a>';
        } else {
          html += '<a class="c9-pill c9-pill--accent" href="' + url('/collections/' + handle + '/' + tag) + '">' + ICON_CAR + 'Only show parts for my ' + esc(g.model + ' ' + (g.c || '')) + '</a>';
        }
      }
      box.querySelector('.c9-scroller').innerHTML = html;
      box.hidden = !html;
    }

    render();
    document.addEventListener('c9:garage', render);
  }

  /* ---------- product fitment ---------- */
  function initFitment(el) {
    if (el.__c9) return; el.__c9 = true;
    var handles = (el.getAttribute('data-handles') || '').split(',').filter(Boolean);
    var universal = el.getAttribute('data-universal') === 'true';
    var status = el.querySelector('[data-c9-fit-status]');
    function render() {
      var g = garage.get(), html = '', cls = 'info', icon = ICON_CAR;
      el.querySelectorAll('[data-fit-handle]').forEach(function (a) { a.classList.toggle('is-mine', !!g && a.getAttribute('data-fit-handle') === g.h); });
      if (universal) {
        cls = 'ok'; icon = ICON_CHECK; html = '<div><strong>Universal fit</strong>Not chassis-specific. Check the description for mounting details.</div>';
      } else if (!g) {
        html = '<div><strong>Will it fit?</strong><button type="button" class="c9-link" data-c9-open>Select your vehicle</button> to check.</div>';
      } else if (handles.indexOf(g.h) > -1) {
        cls = 'ok'; icon = ICON_CHECK; html = '<div><strong>Fits your ' + esc(label(g)) + '</strong>Confirmed for ' + esc(g.c || g.t) + '.</div>';
      } else if (handles.length) {
        cls = 'warn'; icon = ICON_WARN; html = '<div><strong>Not listed for your ' + esc(label(g)) + '</strong><a href="' + url('/pages/contact') + '">Ask us to confirm</a> or <button type="button" class="c9-link" data-c9-open>change vehicle</button>.</div>';
      } else {
        cls = 'warn'; icon = ICON_WARN; html = '<div><strong>Fitment not listed</strong><a href="' + url('/pages/contact') + '">Contact us</a> to confirm before ordering.</div>';
      }
      status.className = 'c9-fit__status c9-fit__status--' + cls;
      status.innerHTML = icon + html;
      status.hidden = false;
    }
    el.addEventListener('click', function (e) { if (e.target.closest('[data-c9-open]')) { e.preventDefault(); openFinder(); } });
    render();
    document.addEventListener('c9:garage', render);
  }

  function openFinder() {
    if (document.querySelector('[data-c9-bar]')) document.dispatchEvent(new CustomEvent('c9:open'));
    else window.location.href = url('/pages/shop-by-vehicle');
  }

  /* ---------- brand search ---------- */
  function initBrandSearch(root) {
    if (root.__c9) return; root.__c9 = true;
    var input = root.querySelector('[data-c9-brand-input]'); if (!input) return;
    var empty = root.querySelector('[data-c9-brand-empty]');
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase(), any = false;
      root.querySelectorAll('[data-c9-brand-group]').forEach(function (grp) {
        var shown = 0;
        grp.querySelectorAll('[data-name]').forEach(function (li) { var hit = !q || li.getAttribute('data-name').indexOf(q) > -1; li.hidden = !hit; if (hit) shown++; });
        grp.hidden = shown === 0; if (shown) any = true;
      });
      if (empty) empty.hidden = any;
    });
  }

  /* ---------- boot ---------- */
  function boot(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-c9-finder]').forEach(initFinder);
    scope.querySelectorAll('[data-c9-bar]').forEach(initBar);
    scope.querySelectorAll('[data-c9-fitment]').forEach(initFitment);
    scope.querySelectorAll('[data-c9-brand-wall]').forEach(initBrandSearch);
    scope.querySelectorAll('[data-c9-open]').forEach(function (b) { if (!b.__c9 && !b.closest('[data-c9-fitment]')) { b.__c9 = true; b.addEventListener('click', function (e) { e.preventDefault(); openFinder(); }); } });
  }

  window.C9 = { garage: garage, data: data, boot: boot, open: openFinder };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
